import { Component, Input } from '@angular/core';

import { Blast3DViewerComponent } from '../blast3-dviewer/blast3-dviewer.component';

/**
 * Lazy loading wrapper for Blast3DViewerComponent.
 * This standalone component uses @defer to lazy load the Three.js heavy 3D viewer
 * only when needed, reducing the initial bundle size.
 */
@Component({
  selector: 'app-blast3-dviewer-lazy',
  standalone: true,
  imports: [Blast3DViewerComponent],
  template: `
    @defer (on viewport) {
      <app-blast3-dviewer [tirId]="tirId" class="available-width" style="height: 70vh; min-height: 500px; max-height: 800px;"></app-blast3-dviewer>
    } @placeholder {
      <div class="d-flex justify-content-center align-items-center" style="height: 70vh; min-height: 500px;">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading 3D viewer...</span>
        </div>
      </div>
    } @loading (minimum 300ms) {
      <div class="d-flex justify-content-center align-items-center" style="height: 70vh; min-height: 500px;">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading 3D viewer...</span>
        </div>
      </div>
    }
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class Blast3DViewerLazyComponent {
  @Input() tirId: number;
}
